import apiClient from '../apiClient';
import { GET_TRANSPORTATION_UNIT_HEADER_BY_ID_URL } from '../apiUrl';

const getTransportationUnitHeaderByIdApi = Id => {
  return apiClient.get(GET_TRANSPORTATION_UNIT_HEADER_BY_ID_URL(Id));
};

export default getTransportationUnitHeaderByIdApi;
